import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { IconButton } from '@scp/ui-shared/components/buttons';
import { color } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons'; // eslint-disable-next-line import/no-relative-parent-imports

import { FullscreenLayoutBase } from '../FullscreenLayoutBase';
import { TEXT } from './constants';
import { closeButtonBase, contentBase, fullscreenLayoutBase } from './baseStyles';
var FullscreenLayout = styled(FullscreenLayoutBase)(_templateObject(), fullscreenLayoutBase);
var Content = styled.div(_templateObject2(), contentBase);
var CloseButton = styled(IconButton)(_templateObject3(), closeButtonBase);
export function WizardLayout(_ref) {
  var onClose = _ref.onClose,
      children = _ref.children;
  return React.createElement(FullscreenLayout, null, !!onClose && React.createElement(CloseButton, {
    title: TEXT.CLOSE_BUTTON_TITLE,
    onClick: onClose
  }, React.createElement(Icon, {
    name: "close",
    color: color.palette.white
  })), React.createElement(Content, null, children));
}